const EngineerThreshold = 0.5;
var ChangeThreshold = /* @__PURE__ */ ((ChangeThreshold2) => {
  ChangeThreshold2[ChangeThreshold2["upper"] = 0.05] = "upper";
  ChangeThreshold2[ChangeThreshold2["lower"] = -0.05] = "lower";
  return ChangeThreshold2;
})(ChangeThreshold || {});
var GrowthType = /* @__PURE__ */ ((GrowthType2) => {
  GrowthType2[GrowthType2["Negligible"] = 0] = "Negligible";
  GrowthType2[GrowthType2["Savings"] = 1] = "Savings";
  GrowthType2[GrowthType2["Excess"] = 2] = "Excess";
  return GrowthType2;
})(GrowthType || {});

export { ChangeThreshold, EngineerThreshold, GrowthType };
//# sourceMappingURL=ChangeStatistic.esm.js.map
